import { useRef, useState } from "react";

import { classNames, Icon } from "@alpacahq/ui/old";

import { useOutsideClick } from "~/v2/api/hooks/useOutsideClick";

export type UBOOption = {
  ownerID: string;
  name: string;
  title: string;
};

export interface UBODropdownButtonProps {
  options: UBOOption[];
  onClick: (ownerID?: UBOOption["ownerID"]) => void;
}

export const UBODropdownButton = ({
  options,
  onClick,
}: UBODropdownButtonProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen((isOpen) => !isOpen);

  const handleClick = (ownerID?: UBOOption["ownerID"]) => () => {
    setIsOpen(false);
    onClick(ownerID);
  };

  useOutsideClick(containerRef, () => setIsOpen(false));

  return (
    <div ref={containerRef} className="relative h-10 w-full max-w-72">
      <button
        type="button"
        onClick={toggleOpen}
        className="grid h-10 w-full grid-cols-[1fr_40px] items-center justify-center rounded border border-yellow-400"
      >
        <span className="flex h-full items-center justify-center text-yellow-900">
          Add Ultimate Beneficial Owner
        </span>
        <span className="flex h-full items-center justify-center border-yellow-400 border-l">
          <Icon name="ChevronDown" size="sm" className="text-yellow-900" />
        </span>
      </button>

      <ul
        className={classNames(
          "absolute top-11 w-full max-w-72 rounded",
          isOpen ? "z-50 flex flex-col shadow" : "hidden",
        )}
      >
        <li className="h-10 bg-white hover:bg-gray-100">
          <button
            type="button"
            onClick={handleClick()}
            className="flex h-10 w-full items-center justify-start gap-2 px-4"
          >
            <span>
              <Icon name="Plus" className="text-gray-800" />
            </span>
            <span className="text-base text-gray-800">
              Add Ultimate Beneficial Owner
            </span>
          </button>
        </li>
        {options.map(({ ownerID, name, title }) => (
          <li
            key={ownerID}
            className="flex h-11 w-full items-center justify-center bg-white hover:bg-gray-100"
          >
            <button
              type="button"
              onClick={handleClick(ownerID)}
              className="flex h-11 w-full flex-col items-start justify-center gap-1 px-4 text-sm"
            >
              <span className="block text-gray-800">{name}</span>
              <span className="block text-gray-500">{title}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
